<app-main-layout
  [clickNext]="onClickNext"
  [clickBack]="onClickBack"
  [activateNextButton$]="nextButtonState.activateNext$"
  >
  @if (sourceForm) {
    <form class="form" [formGroup]="sourceForm">
      <div class="source">
        <h3>One last question{{username ? ', ' + username + '!' : ''}}<br />How did you hear about us? *</h3>
        <div class="names-list">
          @for (item of sources; track item) {
            <div
              class="name"
              (click)="onSelect(item)"
              [ngClass]="{ selected: item.unique_name === selected }"
              >
              {{ item.title }}
            </div>
          }
        </div>
        @if (selected === otherSourceId) {
          <app-form-group
            class="other"
            label="Other"
            [required]="true"
            id="other"
            [counter]="otherTextfieldMaxLength"
            formControlName="other"
            >
          </app-form-group>
        }
      </div>
    </form>
  }
</app-main-layout>
